import { useFeatures } from 'utils/features';

// The Damages table offers Defect Patterns, and applies a `?view=` link to one, only with this
// flag. Links into the table check the same gate, so they never open a table that ignores them.
export const useDefectPatternsEnabled = (): boolean => !!useFeatures().features.BLADE_CARDS;
